module.exports = __webpack_public_path__ + "static/img/环保在线.e49c156.png";


//////////////////
// WEBPACK FOOTER
// ./static/meiti-index/环保在线.png
// module id = JeyN
// module chunks = 1